module.exports = __webpack_public_path__ + "img/homemsg1.5f52bc19.png";